import { mainUrl } from "../../../api/apiSettings";


// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/deliverable
export const CREATE_USER_DELIVERABLE = `${mainUrl}/deliverable`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/deliverable/user/{userId}/{journeyId}
export const QUERY_DELIVERABLES_BY_USER = (userId, journeyId) => `${mainUrl}/deliverable/user/${userId}/${journeyId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/deliverable/journey/{journeyId}
export const QUERY_DELIVERABLES_BY_JOURNEY = (journeyId) => `${mainUrl}/deliverable/journey/${journeyId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/deliverable/{journeyId}/{deliverableId}
export const GET_SPECIFIC_DELIVERABLE = (journeyId, deliverableId) => `${mainUrl}/deliverable/${journeyId}/${deliverableId}`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/review
export const CREATE_REVIEW = `${mainUrl}/review`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/review/{deliverableId}
export const QUERY_REVIEWS_BY_DELIVERABLE = (deliverableId) => `${mainUrl}/review/${deliverableId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/review/{deliverableId}/{reviewerId}
